export default "__VITE_ASSET__CSmQawoC__"